// DO NOT MODIFY, this file is autogenerated by tools/build.ts
export * from 'firebase/storage';
import { ɵzoneWrap } from '@angular/fire';
import {
  connectStorageEmulator as _connectStorageEmulator,
  deleteObject as _deleteObject,
  getBlob as _getBlob,
  getBytes as _getBytes,
  getDownloadURL as _getDownloadURL,
  getMetadata as _getMetadata,
  getStorage as _getStorage,
  getStream as _getStream,
  list as _list,
  listAll as _listAll,
  ref as _ref,
  updateMetadata as _updateMetadata,
  uploadBytes as _uploadBytes,
  uploadBytesResumable as _uploadBytesResumable,
  uploadString as _uploadString
} from 'firebase/storage';

export const connectStorageEmulator = ɵzoneWrap(_connectStorageEmulator, true);
export const deleteObject = ɵzoneWrap(_deleteObject, true);
export const getBlob = ɵzoneWrap(_getBlob, true);
export const getBytes = ɵzoneWrap(_getBytes, true);
export const getDownloadURL = ɵzoneWrap(_getDownloadURL, true);
export const getMetadata = ɵzoneWrap(_getMetadata, true);
export const getStorage = ɵzoneWrap(_getStorage, true);
export const getStream = ɵzoneWrap(_getStream, true);
export const list = ɵzoneWrap(_list, true);
export const listAll = ɵzoneWrap(_listAll, true);
export const ref = ɵzoneWrap(_ref, true);
export const updateMetadata = ɵzoneWrap(_updateMetadata, true);
export const uploadBytes = ɵzoneWrap(_uploadBytes, true);
export const uploadBytesResumable = ɵzoneWrap(_uploadBytesResumable, true);
export const uploadString = ɵzoneWrap(_uploadString, true);
